<div class="row">
  <div class="col-md-8">
    {{ params.data.conversionProcessName }}
  </div>
  <div class="addtooltips align-self-center" class="col-md-4">
    <ng-template #tipContent>
      <div class="row">
        <span class="selectedMaterialDiv d-flex align-items-start justify-content-start">{{
          materialname
        }}</span>
        <div
          class="col-md-12 d-flex align-items-start justify-content-start pt-2"
          *ngFor="let item of materialInfoData | keyvalue; let i = index"
        >
          <ng-container *ngIf="materialInfoDataKey[i] !== 'name'">
            <span class="col-3 d-flex align-items-start justify-content-start alignData"
              >{{ toTitleCase(materialInfoDataKey[i]) }}
            </span>
            <span class="col-1 d-flex align-items-start justify-content-start alignData">:</span>
            <span
              style="text-align: left !important"
              class="col-8 d-flex align-items-start justify-content-start alignData"
              >{{ materialInfoDataValues[i] }}
            </span>
          </ng-container>
        </div>
      </div>
    </ng-template>
    <div
      placement="auto"
      [ngbTooltip]="tipContent"
      tooltipClass="custom-tooltip"
      container="body"
      data-bs-placement="auto"
      (mouseenter)="getIngrientInfo()"
    >
      <a><img src="./assets/icons/info-icon.svg" /></a>
    </div>
  </div>
</div>
